module.exports = __webpack_public_path__ + "img/instagram.28a23d29.svg";